import { useState } from "react";
import { useNavigate } from "react-router";
import BackLink from "../../../components/atoms/BackLink";
import AiAssistantTemplateForm, {
  AiAssistantTemplateFormType,
} from "../../../components/features/AiAssistantTemplateForm";
import type { AiAssistantTemplateFormValues } from "../../../components/features/AiAssistantTemplateForm/validationSchema";
import { UnprocessableEntityError } from "../../../errors";
import { useFlashMessage } from "../../../hooks/useFlashMessage";
import { ApiErrorInterface } from "../../../interfaces/ApiErrorResponseInterface";
import SectionInterface from "../../../interfaces/SectionInterface";
import { useCreateAiAssistantTemplate } from "./useCreateAiAssistantTemplate";

interface Props {
  section: SectionInterface;
}

const SectionsSettingsAiAssistantTemplatesNew = (props: Props) => {
  const [apiErrors, setApiErrors] = useState<ApiErrorInterface[]>([]);
  const navigate = useNavigate();

  const createAiAssistantTemplate = useCreateAiAssistantTemplate({
    sectionId: props.section.id,
  });
  const { showSuccessMessage, showErrorMessage } = useFlashMessage();

  const handleCreateTemplate = (values: AiAssistantTemplateFormValues) => {
    createAiAssistantTemplate.mutate(values, {
      onSuccess: () => {
        showSuccessMessage("テンプレートを作成しました");
        navigate(
          `/sections/${props.section.id}/settings/ai_assistant_templates`,
        );
      },
      onError: (error) => {
        showErrorMessage("テンプレートを作成できませんでした");
        if (error instanceof UnprocessableEntityError) {
          setApiErrors(error.originalErrors);
        }
      },
    });
  };

  return (
    <>
      <BackLink>戻る</BackLink>
      <AiAssistantTemplateForm
        type={AiAssistantTemplateFormType.New}
        aiAssistantTemplate={null}
        submitting={createAiAssistantTemplate.isPending}
        loading={false}
        onSubmit={handleCreateTemplate}
        apiErrors={apiErrors}
      />
    </>
  );
};

export default SectionsSettingsAiAssistantTemplatesNew;
